const modules = import.meta.glob<{ default: string }>('./rotenska-*.jpg', { eager: true });

export const rotenskaImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/rotenska-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/rotenska-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);
